import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'reactstrap'
import "../../../pages/UserProfile/PlansComponent.css"
import "./AppsTrackingPlanModal.css"
import "./ExportUpgradeModal.css"

const ExportUpgradeModal = ({ show, handleClose, onUpgradeClick }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="modal_key app_modal_main">
      <Modal.Header className="export-upgrade-header" closeButton>
        <div className="export-upgrade-title">
          <div className="export-icon" aria-hidden>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#F6255A"/>
              <path d="M12 7v6l4 2" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div>
            <h5>Upgrade your plan to unlock this feature</h5>
            <small className="text-muted">Export available for Premium users.</small>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="export-upgrade-body">
        <div className="export-benefits">
          <div className="benefit">
            <i className="fas fa-check-circle"></i>
            <span>Download CSV, XLSX and PDF</span>
          </div>
          <div className="benefit">
            <i className="fas fa-check-circle"></i>
            <span>Include Publisher and timestamp in filenames</span>
          </div>
          <div className="benefit">
            <i className="fas fa-check-circle"></i>
            <span>Priority export processing</span>
          </div>
        </div>
      </Modal.Body>
      <div className="export-upgrade-footer">
        <Button
          className="btn-upgrade"
          onClick={() => {
            if (onUpgradeClick) onUpgradeClick()
          }}
        >
          Upgrade
        </Button>
      </div>
    </Modal>
  )
}

export default ExportUpgradeModal
